<template>
    <div>
<!--        <div class="content-header">-->
<!--            <h3>查询</h3>-->
<!--            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"-->
<!--                     :size="GCONFIG.styleElFormSize">-->
<!--                <el-form-item label="活动">-->
<!--                    <el-select v-model="formInline.bindCode" clearable filterable placeholder="活动">-->
<!--                        <el-option-->
<!--                                v-for="item in activeOptions"-->
<!--                                :key="item.bindCode"-->
<!--                                :label="item.activeName"-->
<!--                                :value="item.bindCode">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                    <el-button type="primary" @click="getList">查询</el-button>-->
<!--                    <el-button type="success" @click="add()">新增</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
<!--        </div>-->
        <div class="content-wrap">
            <el-table :data="pageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="40"></el-table-column>
                <el-table-column label="bindCode" width="160" prop="bindCode"></el-table-column>
                <!--                <el-table-column prop="activeName" label="活动名称" width="170"></el-table-column>-->
                <el-table-column prop="luckyDrawName" label="抽奖名称" width="170"></el-table-column>
                <el-table-column prop="periodName" label="期次" width="90"></el-table-column>
                <el-table-column prop="luckyDrawStatus" label="抽奖状态" width="80" :formatter="statusShow"  ></el-table-column>
                <el-table-column prop="customerName" label="预约人" width="90"></el-table-column>
                <el-table-column prop="customerImage" label="预约人头像" width="90">
                    <template slot-scope="scope">
                        <el-avatar size="small" :src="scope.row.customerImage"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="subscribeTotalCount" label="总预约次数" width="90" ></el-table-column>
                <el-table-column prop="createTime" label="预约时间" >
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isUsedName" label="是否中奖" width="90" ></el-table-column>
                <el-table-column prop="levelName" label="中将级别" width="90" ></el-table-column>
                <el-table-column prop="prizeName" label="奖项名称"  ></el-table-column>
                <el-table-column prop="usedTime" label="中奖时间" >
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.usedTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isTakeName" label="是否领奖"  width="90"></el-table-column>
                <el-table-column prop="takeTime" label="领奖时间">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.takeTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isFixPrizeName" label="是否内置" ></el-table-column>




                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size="mini" @click="setData(scope.row)">
                                <span>{{scope.row.isFixPrize==1?'取消':'设置'}}</span>
                            </el-button>
                            <el-button type="primary" size="mini" @click="setLineOffTakeDrawSuccess(scope.row)" v-show="scope.row.level==1&&scope.row.takeTime==null" >
                                <span>手工领奖</span>
                            </el-button>
                            <el-button type="success" size="mini" @click="handleDetail(scope.row.customerId)">查看用户</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {luckydraw_getDrawUserList,setDrawPrizeFixUser,setLineOffTakeDrawSuccess} from "../../api/api";
    export default {
        data() {

            return {

                pageList:[],
                formInline: {
                    luckyDrawId: this.$route.query.id || '',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                loading: true,
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据

            this.getList();



        },
        methods: {
            setLineOffTakeDrawSuccess(row){
                var message='确定已经线下给用户发放了奖品，是否继续？';

                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    setLineOffTakeDrawSuccess({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '设置成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            setData(row){
                var message='确定设置该用户为一等奖指定用户？';
                if(row.isFixPrize==1){
                    message='确定取消该用户为一等奖指定用户？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    setDrawPrizeFixUser({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '设置成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            getList(){
                this.loading = true;
                luckydraw_getDrawUserList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.pageList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },



            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            formatDate(datetime) {
                if(datetime==null){
                    return '';
                }
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
          handleDetail(row) {
//                row = '10003238884855992509385'
            this.$router.push({path:'/userSystem/detail/:tab/:id',name: 'userSystemContent',params:{id:row,tab:'info'}})
          },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-order {
        .customer-nick {
            margin: 0;
        }
        .el-table th {
            background: #f1f1f1;
            color: #222222;
        }
        .el-table__expanded-cell {
            background: #f5f5f5;
            text-align: left;
            padding: 7px 50px;
        }
        .el-table__expanded-cell:hover {
            background: #f5f5f5 !important;
        }
        .expand-title {
            width: 70px;
            color: #444548;
            line-height: 30px;
            text-align: right;
            margin-right: 10px;
            font-weight: 600;
        }
        .expand-flex, .expand-flex-con {
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
        .expand-flex-con {
            display: flex;
            flex-wrap: wrap;
            .expand-content {
                margin: 5px 10px 5px 0;
            }
        }
        .el-table__expand-icon > .el-icon {
            font-size: 16px;
            font-weight: bolder;
        }
        .el-divider--horizontal {
            margin: 10px 0;
        }
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/lucky/luckydrawUserList.vue